<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: JobItem
 * @Description: 职位介绍组件
 * @FilePath: /app-tikfriend_web/src/components/JobItem.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-12 09:31:47
 * @LastEditors: hselenat
 * @LastEditTime: 2021-08-12 10:28:19
 * @example: 调用示例
-->
<template>
  <div class="job-items">
    <div class="job-item" v-for="(item, index) in jobItemData" :key="index">
      <div class="job-title"><pre>{{ item.name }}</pre></div>
      <div class="job-jobs">{{ item.city }} | {{ item.job }}</div>
      <div class="job-subtitle"><pre>职位描述</pre></div>
      <div class="job-describ">
          <ul v-for="(descItem, descIdx) in item.description" :key="'desc' + descIdx">
              <li>{{ descItem }}</li>
          </ul>
      </div>
      <div class="job-subtitle"><pre>职位要求</pre></div>
      <div class="job-describ">
          <ul v-for="(reqItem, reqIdx) in item.requirements" :key="'req' + reqIdx">
              <li>{{ reqItem }}</li>
          </ul>
      </div>
    </div>
</div>
</template>

<script>
  export default {
    name: 'JobItem',
    props: {
      jobItemData: {
        type: Array,
        default: []
      }
    }
  }
</script>
